<template>
  <el-card
    shadow="never"
    :body-style="{
      padding: '20px 15px',
    }"
  >
    <div v-if="!isEmpty">
      <Timeline>
        <TimelineItem
          v-for="(item, index) in trackingFabricList"
          :key="index"
          v-bind="item"
        >
          <template #default="{ item }">
            <FabricSpec
              ref="fabricSpecRef"
              :specInfo="item"
              class="mt-2"
            ></FabricSpec>
          </template>
        </TimelineItem>
      </Timeline>
    </div>
    <div v-else class="not-data__container">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
  </el-card>
</template>
<script>
import Timeline from '../timeline/index.vue'
import TimelineItem from '../timeline/item.vue'
import FabricSpec from './fabric-spec'
export default {
  components: { Timeline, TimelineItem, FabricSpec },
  props: {
    devTrackingCode: { log: String, default: '' },
  },
  data() {
    return {
      trackingFabricList: [],
      logList: [],
      fileIcons: {},
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    isEmpty() {
      return !this.trackingFabricList || !this.trackingFabricList.length
    },
  },
  methods: {
    getData() {
      if (!this.devTrackingCode) return
      this.trackingFabricList = [
        {
          type: 'T',
          title: '面料打样单号：MP202401190001',
          time: '2024-01-10 10:10:30',
          name: '无名小卒',
          avatar: '',
          content: [
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
          ],
        },
        {
          type: 'T',
          title: '面料打样单号：MP202401190002',
          time: '2024-01-10 10:10:30',
          name: '无名小卒',
          avatar: '',
          content: [
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
            {
              fabricColorNo: 'ABS23080129-10',
              fabricColorTitle: '白色',
              defaultImageUrl:
                'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
              fabricPositionName: '正面',
              fabricName: '素色 雪尼尔',
              fabricWeightUnit: '400 gsm',
              fabricContent: '48% 涤纶; 20% 粘胶; 32% 棉',
              isSpecify: 'Y',
              isCustomerProvide: 'Y',
              scmName: '大连丰深科贸有限公司',
            },
          ],
        },
      ]
      // this.loading = true
      // this.$api
      //   .masterCustomerDevTrackingLogListApi({
      //     devTrackingCode: this.devTrackingCode,
      //   })
      //   .then((res) => {
      //     this.loading = false
      //     this.trackingLogList = res.body.data || []
      //     this.logList = res.body.data || []
      //   })
      //   .catch(() => {
      //     this.loading = false
      //   })
    },
  },
}
</script>
<style lang="scss" scoped>
.imageClass {
  border: 1px #bbbbbb dashed;
  border-radius: 50px;
  background-color: white;
  text-align: center;
  height: 30px;
  width: 30px;
  line-height: 24px;
}
.titleText {
  font-size: 14px;
  color: #101010;
  font-weight: 600;
}
.descriptionText {
  font-size: 12px;
  color: #8f97ad;
}
.headImage {
  margin: 0 5px;
  width: 20px;
  height: 20px;
}
.desc_body_class {
  flex-wrap: wrap;
  border: 1px #bbbbbb dashed;
  padding: 13px 15px;
  margin: 15px 0px;
}
.desc_body-item {
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.desc_body-item__image {
  background-color: rgba(244, 246, 249, 1);
  border-radius: 5px;
  padding: 5px;
}
.not-data__container {
  height: 500px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.task_left_class {
  color: #8e8e8e;
  font-size: 14px;
  font-weight: 600;
}
.task_right_class {
  color: #303133;
  font-size: 14px;
}
::v-deep {
  .timeline-item__content .timeline-item__content__title {
    font-size: 14px;
    color: #101010;
    font-weight: bold;
  }
}
</style>
